<template>
  <div class="loading">
    <div class="loading-animat" v-if="loadingState">
      <div class="dot dot1"></div>
      <div class="dot dot2"></div>
      <div class="dot dot3"></div>
      <div class="dot dot4"></div>
      <div class="dot dot5"></div>
      <div class="dot dot6"></div>
      <div class="dot dot7"></div>
      <div class="dot dot8"></div>
    </div>
    <div class="loading-static" v-else>
      <div class="dot-static dot1"></div>
      <div class="dot-static dot2"></div>
      <div class="dot-static dot3"></div>
      <div class="dot-static dot4"></div>
      <div class="dot-static dot5"></div>
      <div class="dot-static dot6"></div>
      <div class="dot-static dot7"></div>
      <div class="dot-static dot8"></div>
    </div>
    <div class="text">
      {{ loadingState ? loadText["loading"] : loadText["finished"] }}
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";


export default {
  name: "loading",
  data() {
    return {};
  },
  props:['loadingState'],
  computed: {
    loadText() {
      return {
        loading:i18n.global.t("Analysing"),
        finished:i18n.global.t("Finished")
      };
    }
  },
  mounted() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.$emit("update:loadingState", false);
    }, 5000);
  },
  methods: {},
  components: {}
};
</script>

<style scoped lang="scss">
$width: 130px;
$height: 130px;
$dotwidth: 20px;
$dotheight: 20px;
$radius: 8px;
$offset: 16px;

@keyframes changeopacity {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.2;
  }
}
.loading {
  width: $width;
  height: $height;
  z-index: 99999;

  .dot {
    width: $dotwidth;
    height: $dotheight;
    position: absolute;
    background: conic-gradient(
      from 65.38deg at 50% 50%,
      #04ffff 0deg,
      #04ffff 360deg
    );
    border-radius: 50% 50%;
    opacity: 1;
    animation: changeopacity 1.04s ease infinite;
  }
  .dot-static {
    width: $dotwidth;
    height: $dotheight;
    position: absolute;
    background: conic-gradient(
      from 65.38deg at 50% 50%,
      #04ffff 0deg,
      #04ffff 360deg
    );
    border-radius: 50% 50%;
  }
  .dot1 {
    left: 0;
    top: 50%;
    margin-top: -$radius;
    animation-delay: 0.13s;
  }
  .dot2 {
    left: $offset;
    top: $offset;
    animation-delay: 0.26s;
  }
  .dot3 {
    left: 50%;
    top: 0;
    margin-left: -$radius;
    animation-delay: 0.39s;
  }
  .dot4 {
    top: $offset;
    right: $offset;
    animation-delay: 0.52s;
  }
  .dot5 {
    right: 0;
    top: 50%;
    margin-top: -$radius;
    animation-delay: 0.65s;
  }
  .dot6 {
    right: $offset;
    bottom: $offset;
    animation-delay: 0.78s;
  }
  .dot7 {
    bottom: 0;
    left: 50%;
    margin-left: -$radius;
    animation-delay: 0.91s;
  }
  .dot8 {
    bottom: $offset;
    left: $offset;
    animation-delay: 1.04s;
  }

  .text {
    font-size: 16px;
    width: 50%;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
